export default {
    props: {
      header: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        index: 0,
        show: false
      }
    },
    computed: {
      show() {
        return this.$parent.activeIndex === this.index
      },
      transition() {
        return this.$parent.effect
      }
    },
    created() {
      this.$parent.renderData.push({
        header: this.header,
        disabled: this.disabled
      })
    },
    ready() {
      this.index = [...this.$el.parentNode.children].indexOf(this.$el)
    }
  }


/** WEBPACK FOOTER **
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/Tab.vue
 **/